import React,{Component} from "react";
class TitleCont extends Component{
    render() {
        const {title,subtitle} =  this.props;
        return (
            <>
                <div className="titleCont txt-center">
                    <div className="title fs2 txt-center">
                        <h2 className="fs3">{title}</h2>
                        <p className="fs1_2">{subtitle}</p>
                    </div>
                </div>
            </>
        );
    }
}
export default TitleCont;